import { render, staticRenderFns } from "./CloseForm.vue?vue&type=template&id=3ab56b39"
import script from "./CloseForm.vue?vue&type=script&lang=js"
export * from "./CloseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports